import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0b7b0cef&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7b0cef')) {
      api.createRecord('0b7b0cef', component.options)
    } else {
      api.reload('0b7b0cef', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0b7b0cef&", function () {
      api.rerender('0b7b0cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RMAjWYr1z197/JS/offershelp.vue"
export default component.exports